<p-panel header="Ordering Provider Details" [toggleable]="true" [collapsed]="isPASComplete" toggler="header">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
  </ng-template>
    @if (orderingData) {
      <div>
        @if (!orderingProviderData.provider) {
          <div class="mb-4">
            <p-checkbox
              data-test-id="provider-npi-not-found-checkbox"
              [binary]="true"
              [disabled]="true"
              [ngModel]="true"
            ></p-checkbox>
            <label data-test-id="provider-npi-not-found-label"> Ordering Provider not found </label>
          </div>
        }
        @if (orderingProviderData.provider) {
          <div class="mb-4">
            <span class="col font-semibold">{{orderingProviderData.provider.physicianAccountViewDTO.accountName}}</span>
          </div>
        }
        <p-panel [header]="panelName">
          <div
            class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned"
            >
            <div class="col-span-6">
              @if (orderingProviderData.provider) {
                <div>
                  <div class="field">
                    <label data-test-id="provider-npi-label">NPI: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.practiceNpinumber }}
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label data-test-id="provider-tax-id-label">Tax ID: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.practiceTaxId | emptyPlaceholder }}
                      </div>
                    </div>
                  </div>
                  @if (isGoldCardVisible) {
                    <div class="field">
                      <label>Gold Card Provider:</label>
                      <div class="p-field-value">
                        <div class="readonly-field">
                          <p-checkbox
                            [binary]="true"
                            [disabled]="true"
                            data-test-id="gold-card-checkbox"
                            [ngModel]="isGoldCardProvider"
                            >
                          </p-checkbox>
                        </div>
                      </div>
                    </div>
                  }
                  @if (isGoldCardProvider) {
                    <div class="field">
                      <label data-test-id="gold-card-auth-type-label">Gold Card Auth Type:</label>
                      <div class="p-field-value">
                        <div class="readonly-field">{{ goldCardAuthorizationType | emptyPlaceholder }}</div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (orderingProviderData.physicianContact) {
                <div>
                  <div class="field">
                    <label data-test-id="provider-first-name-label">First Name: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.firstName }}
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label data-test-id="provider-last-name-label">Last Name: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.lastName }}
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label data-test-id="provider-npi-label">NPI: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.practiceNpinumber }}
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label data-test-id="provider-tax-id-label">Tax ID: </label>
                    <div class="p-field-value">
                      <div class="readonly-field">
                        {{ orderingData.practiceTaxId | emptyPlaceholder }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="col-span-6">
              <div class="field">
                <label data-test-id="provider-street-label">Street: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ orderingData.physicalStreet | emptyPlaceholder }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="provider-city-label">City: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ orderingData.physicalCity | emptyPlaceholder }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="provider-state-label">State: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ orderingData.physicalState | emptyPlaceholder }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="provider-zip-label">ZIP Code: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ orderingData.physicalZip | zipCode | emptyPlaceholder }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="provider-phone-label">Phone: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ orderingData.phone | phoneNumber }}
                  </div>
                </div>
              </div>
              @if (!orderingProviderData.provider) {
                <div class="field">
                  <label data-test-id="provider-fax-label">Fax: </label>
                  <div class="p-field-value">
                    <div class="readonly-field">
                      {{ orderingData.fax | phoneNumber }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </p-panel>
      </div>
    }
</p-panel>
